<template>
  <div class="calico-file-item-page">
    <div class="calico-file-item-container">
      <CalicoFileItem
        :progress="0"
        :on-close="onClose"
      />
      <CalicoFileItem
        :progress="30"
        :on-close="onClose"
      />
      <CalicoFileItem
        completed
        :on-trash="onTrash"
      />
      <CalicoFileItem
        :progress="100"
        error
        :on-trash="onTrash"
        message="Error message goes here."
      />
    </div>
    <div class="calico-file-item-container-2">
      <CalicoFileItem
        :progress="0"
        :dark="true"
        :on-close="onClose"
      />
      <CalicoFileItem
        :progress="30"
        :dark="true"
        :on-close="onClose"
      />
      <CalicoFileItem
        completed
        :dark="true"
        :on-trash="onTrash"
      />
      <CalicoFileItem
        :progress="100"
        :dark="true"
        error
        :on-trash="onTrash"
        message="Error message goes here."
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoFileItem from '@/components/calico/fileItem/index.vue'
export default {
  name: 'CalicoFileItemPage',
  components: {
    CalicoFileItem
  },
  data () {
    return {}
  },
  methods: {
    onClose () {
      console.log('closed!')
    },
    onTrash () {
      console.log('trashed!')
    }
  }
}
</script>
<style lang="scss">
.calico-file-item-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  .calico-file-item-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 459px;
  }
  .calico-file-item-container-2 {
    @include stack-space($space-large);
    @include inset-space($space-large);
    background: $color-neutral-darkest;
    width: 459px;
  }
}
</style>
